import React from 'react'
import { ViewHeader } from '../common'
import LeaguesConfigDropdowns from './LeaguesConfigDropdowns'
import LeaguesConfigOptions from './LeaguesConfigOptions'

const LeaguesConfig = () => {
  return (
      <div className="cls-lc-main">
        <ViewHeader
          title={window.I18n.t('clone_leagues_sessions.leagues_configs.title')}
          description={window.I18n.t('clone_leagues_sessions.leagues_configs.description')}
        />
        <div className={'cls-lcd-container'}>
          <LeaguesConfigDropdowns/>
          <LeaguesConfigOptions />
        </div>
      </div>
  )
}

export default LeaguesConfig
